<script>
import DetilRiwayatPembayaran from './DetilRiwayatPembayaran.vue';
import axios from 'axios';
import { mdiDockWindow } from '@mdi/js';
import numeral from 'numeral';

export default {
    name: "RiwayatPembayaran",
    components: { DetilRiwayatPembayaran },
    data() {
        return {
            icons: { mdiDockWindow },
            
            isLoading: false,
            tableHeaders: [
                { text: 'No. Pembayaran', value: 'no_pembayaran' },
                { text: 'Jenis', value: 'source_description' },
                { text: 'Tanggal Transaksi', value: 'tanggal_pembayaran' },
                { text: 'Tagihan', value: 'tagihan' },
                { text: 'Terbayar', value: 'terbayar' },
                { text: 'Aksi', value: 'action' },
            ],
            tableItems: [],
            options: {},
            pagination: {
                currentPage: 1,
                lastPage: 0,
                perPage: 0,
                total: 0
            },

            dialog: false,
            selectedItem: null,
        }
    },
    methods: {
        
        openDialog(item) {
            this.selectedItem = item;
            this.dialog = true;
        },

        fetchData() {
            this.isLoading = true;

            const { page = 1, itemsPerPage = 10 } = this.options;

            axios.get(`${process.env.VUE_APP_ROOT_API}/api/ortu/riwayat-pembayaran`, {
                params: { page }
            }).then(({ data }) => {
                const riwayat = data.riwayat;

                this.pagination.currentPage = riwayat.current_page;
                this.pagination.lastPage = riwayat.last_page;
                this.pagination.perPage = riwayat.per_page;
                this.pagination.total = riwayat.total;

                this.tableItems = riwayat.data.map(item => ({
                    source: item.source,
                    receipt_id: item.receipt_id,
                    source_description: item.source_description,
                    no_pembayaran: item.no_pembayaran,
                    tanggal_pembayaran: item.tanggal_pembayaran,
                    tagihan: `Rp ${numeral(item.tagihan).format('0,0')}`,
                    terbayar: `Rp ${numeral(item.terbayar).format('0,0')}`
                }));
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onOptionsChanged(newOptions) {
            const { page, itemsPerPage } = newOptions;

            const pageChanged = page !== this.options.page;
            const perPageChanged = itemsPerPage !== this.options.itemsPerPage;

            this.options = { ...newOptions };

            if (pageChanged || perPageChanged) {
                this.fetchData();
            }
        },

        onPageChanged() {
            this.options.page = this.pagination.currentPage;
            this.fetchData();
        }
    },
    mounted() {
        this.options = { page: 1, itemsPerPage: 10 };
        this.fetchData();
    }
}
</script>

<template>
    <div class="riwayat-pembayaran-container">
        <v-data-table 
            :loading="isLoading"
            :headers="tableHeaders" 
            :items="tableItems" 
            :options.sync="options" 
            :page="pagination.currentPage"
            :pageCount="pagination.lastPage" :items-per-page="pagination.perPage"
            :server-items-length="pagination.total" 
            @update:options="onOptionsChanged"
            hide-default-footer 
            class="elevation-1"
        >
            <template v-slot:item.action="{ item }">
                <v-btn outlined small color="accent" @click="openDialog(item)">
                    Lihat Rincian
                    <v-icon class="ms-2">{{ icons.mdiDockWindow }}</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-pagination
            v-model="pagination.currentPage"
            :length="pagination.lastPage"
            @input="onPageChanged"
        />

        <DetilRiwayatPembayaran :dialog.sync="dialog" :item="selectedItem" />
    </div>
</template>
